import request from '@/utils/request'
import { baseApiUrl } from './config'
// 登录方法
export function login(data) {
  return request({
    url: baseApiUrl + '/login',
    method: 'post',
    data: data,
  })
}
// 修改token时间
export function change_login_time(data) {
  return request({
      url: baseApiUrl + "/change_login_time",
      headers: { Authorization: "Bearer " +  JSON.parse(window.localStorage.getItem("resdata")).data.token },
      data,
      method: "POST"
  })
}
// 软件列表
export function get_apply_soft_list(data) {
  return request({
      url: baseApiUrl + "/get_apply_soft_list",
      headers: { Authorization: "Bearer " +  JSON.parse(window.localStorage.getItem("resdata")).data.token },
      data,
      method: "POST"
  })
}
//软件详情
export function get_apply_soft_info(data) {
  return request({
      url: baseApiUrl + "/get_apply_soft_info",
      headers: { Authorization: "Bearer " +  JSON.parse(window.localStorage.getItem("resdata")).data.token },
      data,
      method: "POST"
  })
}
//软件新增
export function add_apply_soft(data) {
  return request({
      url: baseApiUrl + "/add_apply_soft",
      headers: { Authorization: "Bearer " +  JSON.parse(window.localStorage.getItem("resdata")).data.token },
      data,
      method: "POST"
  })
}
// 文件上传接口
export function upload(data) {
  return request({
      url: baseApiUrl + "/file_upload",
      data,
      headers: { "Content-Type": "multipart/form-data",
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
export function get_file_url(data) {
  return request({
      url: baseApiUrl + "/get_file_url",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//上传压缩文件
export function file_upload_compressed(data) {
  return request({
      url: baseApiUrl + "/file_upload_compressed ",
      data,
      headers: { "Content-Type": "multipart/form-data",
        Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
     },
      method: "POST"
  })
}
//压缩文件列表
export function object_name_list(data) {
  return request({
      url: baseApiUrl + "/object_name_list ",
      data,
    //   headers: { 
    //     Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
    //  },
      method: "POST"
  })
}
//下载压缩文件
export function get_compressed_file_url(data) {
  return request({
      url: baseApiUrl + "/get_compressed_file_url ",
      data,
     
      method: "POST"
  })
}
//删除
export function del_apply_soft(data) {
  return request({
      url: baseApiUrl + "/del_apply_soft",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//修改
export function change_apply_soft(data) {
  return request({
      url: baseApiUrl + "/change_apply_soft",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//硬件列表
export function get_apply_hardware_list(data) {
  return request({
      url: baseApiUrl + "/get_apply_hardware_list",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//硬件详情
export function get_apply_hardware_info(data) {
  return request({
      url: baseApiUrl + "/get_apply_hardware_info",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//硬件添加
export function add_apply_hardware(data) {
  return request({
      url: baseApiUrl + "/add_apply_hardware",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//硬件修改
export function change_apply_hardware(data) {
  return request({
      url: baseApiUrl + "/change_apply_hardware",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//硬件删除
export function del_apply_hardware(data) {
  return request({
      url: baseApiUrl + "/del_apply_hardware",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//计数器
export function redis_count(data) {
  return request({
      url: baseApiUrl + "/redis_count",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源软件
export function open_source_software_list(data) {
  return request({
      url: baseApiUrl + "/open_source_software_list",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源软件新增
export function open_source_software_add(data) {
  return request({
      url: baseApiUrl + "/open_source_software_add",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源软件删除
export function open_source_software_deleted(data) {
  return request({
      url: baseApiUrl + "/open_source_software_deleted",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源软件修改
export function open_source_software_change(data) {
  return request({
      url: baseApiUrl + "/open_source_software_change",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//编程语言
export function get_language_ids(data) {
  return request({
      url: baseApiUrl + "/get_language_ids",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//论坛列表
export function forum_post_list(data) {
  return request({
      url: baseApiUrl + "/forum_post_list",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//论坛详情
export function forum_post_info(data) {
  return request({
      url: baseApiUrl + "/forum_post_info",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//论坛修改
export function change_forum_post(data) {
  return request({
      url: baseApiUrl + "/change_forum_post",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//论坛增加
export function add_forum_post(data) {
  return request({
      url: baseApiUrl + "/add_forum_post",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//论坛删除
export function del_forum_post(data) {
  return request({
      url: baseApiUrl + "/del_forum_post",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源硬件
export function open_source_hardware_list(data) {
  return request({
      url: baseApiUrl + "/open_source_hardware_list",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源硬件新增
export function open_source_hardware_add(data) {
  return request({
      url: baseApiUrl + "/open_source_hardware_add",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源硬件删除
export function open_source_hardware_deleted(data) {
  return request({
      url: baseApiUrl + "/open_source_hardware_deleted",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//开源硬件修改
export function open_source_hardware_change(data) {
  return request({
      url: baseApiUrl + "/open_source_hardware_change",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//审核
export function submit_examine(data) {
  return request({
      url: baseApiUrl + "/submit_examine",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//发布
export function publish_operation(data) {
  return request({
      url: baseApiUrl + "/publish_operation",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//用户信息修改
export function change_user_info(data) {
  return request({
      url: baseApiUrl + "/change_user_info",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
//用户密码修改
export function change_pwd(data) {
  return request({
      url: baseApiUrl + "/change_pwd",
      data,
      headers: { 
          Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
       },
      method: "POST"
  })
}
// 令牌
export function mcp_token(data) {
  return request({
      url: baseApiUrl + "/mcp_token",
      data,
      headers: { 
        Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
     },
      method: "get"
  })
}
// 令牌
export function mcp_token2(data) {
  return request({
      url: baseApiUrl + "/mcp_token",
      data,
      headers: { 
        Authorization: "Bearer " +   JSON.parse(window.localStorage.getItem("resdata")).data.token
     },
      method: "POST"
  })
}
//nclink认证
export function auth_info(data) {
  return request({
      url: baseApiUrl + "/auth_info",
      data,
      method: "POST"
  })
}
//云展厅列表
export function cloud_hall_list(data) {
  return request({
      url: baseApiUrl + "/cloud_hall_list",
      data,
      method: "POST"
  })
}
//云展厅列表详情
export function cloud_hall_info(data) {
  return request({
      url: baseApiUrl + "/cloud_hall_info",
      data,
      method: "POST"
  })
}
//新闻
export function news_list(data) {
  return request({
      url: baseApiUrl + "/news_list",
      data,
      method: "POST"
  })
}
//新闻详情
export function news_info(data) {
  return request({
      url: baseApiUrl + "/news_info",
      data,
      method: "POST"
  })
}
//连接服务
export function link_service_info(data) {
  return request({
      url: baseApiUrl + "/link_service_info",
      data,
      method: "POST"
  })
}
//关于nclink
export function about_nc_link_info(data) {
  return request({
      url: baseApiUrl + "/about_nc_link_info",
      data,
      method: "POST"
  })
}
//应用软件
export function get_apply_soft_tourist_list(data) {
  return request({
      url: baseApiUrl + "/get_apply_soft_tourist_list",
      data,
      method: "POST"
  })
}
//应用硬件
export function get_apply_hardware_tourist_list(data) {
  return request({
      url: baseApiUrl + "/get_apply_hardware_tourist_list",
      data,
      method: "POST"
  })
}
//开源软件
export function open_source_software_list1(data) {
  return request({
      url: baseApiUrl + "/open_source_software_list",
      data,
      method: "POST"
  })
}
//开源硬件
export function open_source_hardware_list1(data) {
  return request({
      url: baseApiUrl + "/open_source_hardware_list",
      data,
      method: "POST"
  })
}
//游客详情图片
export function get_admin_file_url(data) {
  return request({
      url: baseApiUrl + "/get_admin_file_url",
      data,
      method: "POST"
  })
}



